import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Countries } from '../../model/countries';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  url = environment.API_URL;
  constructor(private http: HttpClient) { }

  getAll(): Observable<Countries[]>{
    return this.http.get<Countries[]>(`${this.url}country-info`);
  }
  
  getById(id:number): Observable<Countries>{
    return this.http.get<Countries>(`${this.url}country-info/${id}`);
  }
}
